import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDiscussion, useReport } from "../..";
import { addComment } from "../../api/reportsApi";
import CommentsModal from "../problemsSection/CommentsModal";
import AuditHistoryButton from "../AuditHistoryButton";

export const DiscussionComponent = ({ resourceId }: { resourceId: string }) => {
  const { report } = useReport();
  const { discussion } = useDiscussion();
  const queryClient = useQueryClient();

  const { mutate: addReviewComment } = useMutation(
    async ({ value }: { value: string }) =>
      await addComment(report.id, resourceId, value),
    {
      onSuccess: () => {
        queryClient.resetQueries(["Discussion"]);
      },
    }
  );

  return (
    <>
      <CommentsModal
        comments={discussion.get(resourceId) ?? []}
        addItem={(val) => addReviewComment({ value: val })}
        reportId={report.id}
      />

      <AuditHistoryButton resourceId={resourceId} resourceName={""} />
    </>
  );
};


export function DiscussionHistoryInline({ resourceId }: { resourceId: string }) {
  return (
    <div
      className="
        inline-flex items-center justify-center gap-1 w-[80px]
        [&>*]:inline-flex [&>*]:items-center [&>*]:justify-center
        [&>*]:h-8 [&>*]:w-8 [&>*]:rounded-full
        [&>*]:hover:bg-[var(--sc-bg)] [&>*]:transition
      "
    >
      <DiscussionComponent resourceId={resourceId} />
    </div>
  );
}


export const EditIcon = ({ className = "h-5 w-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M16.862 3.487a1.75 1.75 0 0 1 2.475 2.475l-10.4 10.4a2 2 0 0 1-.848.503l-3.43.98a.5.5 0 0 1-.617-.617l.98-3.43a2 2 0 0 1 .503-.848l10.337-10.337z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M14.5 5.5l4 4" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

export const TrashIcon = ({ className = "h-5 w-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 7h16M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M10 11v6M14 11v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);
